import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="validators"
export default class extends Controller {
  static targets = ["checkbox", "submit", "userRow"]

  connect() {
    console.log("Validators controller connected")
  }

  toggleValidator(event) {
    // Get the user ID from the checkbox
    const userId = event.target.dataset.userId
    
    // Find the submit button for this user
    const submitButton = this.submitTargets.find(target => 
      target.dataset.userId === userId
    )
    
    // Submit the form
    if (submitButton) {
      submitButton.click()
    }
  }
} 